export const REGEX_STRINGS = {
  isFileUploading: /<!-- Uploading[\s\S]*?-->/,
}
